import React from 'react';
import PropTypes from 'prop-types';

import BackLink from 'rebook/apps/base/components/BackLink';

import styles from './style.scss';


const BookReviewCitationHeader = ({ title, bookName, link, isCitation }) => {
  const breadCrumbsText = isCitation ? 'Цитаты из книги' : 'Отзывы на книгу';
  const breadCrumbsLink = isCitation ? `${link.pathname}citations/` : `${link.pathname}reviews/`;

  return (
    <div className={styles.container}>
      <BackLink link={breadCrumbsLink}>
        <span>{breadCrumbsText} &laquo;{bookName}&raquo;</span>
      </BackLink>
      <div className="sectionHeader">
        <h1>{title}</h1>
      </div>
    </div>
  );
};

BookReviewCitationHeader.propTypes = {
  bookName: PropTypes.string.isRequired,
  link: PropTypes.object.isRequired,
  isCitation: PropTypes.bool,
};

export default BookReviewCitationHeader;
